import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import SetMenuItem from "@/model/setMenuItem";

@Module({ namespaced: true })
export default class SetMenuItemModule extends VuexModule {
  public setMenuItem: SetMenuItem = null;
  public setMenuItemList: SetMenuItem[] = [];

  @Mutation
  set(setMenuItem: SetMenuItem): void {
    this.setMenuItem = setMenuItem;
  }

  @Mutation
  setSetMenuItemList(setMenuItem: SetMenuItem[]): void {
    this.setMenuItemList = setMenuItem;
  }

  @Mutation
  addSetMenuItemList(setMenuItem: SetMenuItem): void {
    this.setMenuItemList.push(setMenuItem);
  }

  @Mutation
  editSetMenuItemList(setMenuItem: SetMenuItem): void {
    this.setMenuItemList.map((value, key) => {
      if (value.identifier === setMenuItem.identifier) {
        this.setMenuItemList.splice(key, 1, setMenuItem)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.setMenuItemList.splice(index, 1);
  }

  @Action({ rawError: true })
  setAMenuItem(setMenuItem: SetMenuItem) {
    this.context.commit("set", setMenuItem);
  }

  @Action({ rawError: true })
  addSetMenuItemToList(setMenuItem: SetMenuItem) {
    this.context.commit("addSetMenuItemList", setMenuItem);
  }

  @Action({ rawError: true })
  editSetMenuItemToList(setMenuItem: SetMenuItem) {
    this.context.commit("editSetMenuItemList", setMenuItem);
  }

  @Action({ rawError: true })
  removeSetMenuItemInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setSetMenuItemList", []);
  }

  get getMenuItem(): SetMenuItem {
    return this.setMenuItem;
  }

  get getSetMenuItemList(): SetMenuItem[] {
    return this.setMenuItemList;
  }

  @Mutation
  setQuantity(value: any): void {
    this.setMenuItemList.map(item => {
      if (item.identifier === value.identifier) {
        item.quantity = value.quantity
      }
    })
  }

  @Action({ rawError: true })
  setQuantityToSetMenuItemItem(value: any) {
    this.context.commit("setQuantity", value);
  }
}
